import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-[400px] lg:max-w-[500px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] max-w-[300px] mx-auto lg:max-w-none">
              <img
                src={appData.image}
                alt="密桃视频移动端观影体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              {appData.subtitle}
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              {appData.desc}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-8 max-w-[400px] mx-auto lg:mx-0">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  <span className="whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line"></i>
              立即体验移动观影
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}